import { useBreakPoints } from 'core';
import {
  Affix,
  Card,
  CarouselWithPreview,
  Container,
  Divider,
  Grid,
  Stack,
  Text,
  Title,
  TransitionElement,
} from 'ui';

import classes from './HolidayPromotionPage.module.css';
import { AMessage } from './components/AMessage';
import { Actions } from './components/Actions';
import { DonateModal } from './components/DonateModal';
import { ExtensionModal } from './components/ExtensionModal';
import { HeaderImage } from './components/HeaderImage';
import { Katherine } from './components/Katherine';
import { Milestones } from './components/Milestones';
import { RaisedSoFar } from './components/RaisedSoFar';
import { RecentActivity } from './components/RecentActivity';
import { WaysToParticipate } from './components/WaysToParticipate';

const Experiment_HolidayPromotion = () => {
  const { isSmallScreen } = useBreakPoints();
  return (
    <>
      <Container fluid maw={1200} mb={80}>
        <Grid>
          <Grid.Col span={isSmallScreen ? 12 : 7}>
            <Stack gap={32}>
              <CarouselWithPreview
                slides={[
                  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/holidayPromotion/header1.png',
                  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/holidayPromotion/header2.png',
                  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/holidayPromotion/header3.png',
                  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/holidayPromotion/header4.png',
                  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/holidayPromotion/header5.png',
                  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/holidayPromotion/header6.png',
                ]}
                header={<HeaderImage />}
                ratio={2 / 1}
              />
              <Stack gap={5}>
                <Title>The Gift It Forward Campaign</Title>
                <Text fz={isSmallScreen ? 24 : 18}>
                  Unlock 1,000 holiday gifts for kids in foster care*
                </Text>
              </Stack>
              {isSmallScreen && <RaisedSoFar />}
              <Stack gap={'xs'}>
                <Text fz={16}>
                  Be a part of the reason 1000 kids in foster care have gifts to open this holiday
                  season. Every action unlocks a $5 donation!
                </Text>
                <Text fz={16}>
                  Simply download the Givebacks extension on your iPhone or Chrome desktop browser
                  or make a donation to your favorite nonprofit.
                </Text>

                <Text fz={12} c="gray.6">
                  *Number of gifts is based on an average of $50 per gift.
                </Text>
              </Stack>
              <WaysToParticipate />
              <Katherine />
              <Milestones />
              <AMessage />
              <RecentActivity />
            </Stack>
          </Grid.Col>

          {!isSmallScreen && (
            <Grid.Col span={5}>
              <Card
                style={{ boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)' }}
                p={'xl'}
                className={classes.rightContentChild}
              >
                <Stack gap={24}>
                  <RaisedSoFar />
                  <Divider />
                  <Actions />
                </Stack>
              </Card>
            </Grid.Col>
          )}
        </Grid>

        <Affix left={'0'} right={0} withinPortal={false}>
          <TransitionElement mounted={!!isSmallScreen}>
            <Stack p="md" bg="linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 35.23%)">
              <Actions />
            </Stack>
          </TransitionElement>
        </Affix>
      </Container>

      <DonateModal />
      <ExtensionModal />
    </>
  );
};

export { Experiment_HolidayPromotion };
